<div class="switch-policy" *ngIf="isTogglePolicy" (click)="closeBanner()">
  <div class="check-circle"><img src="../../../../../assets/images/check-circle.svg"></div>
  <div class="title"> Now you’re switched to policy number: {{currentPolicy}}</div>
</div>